export default __webpack_public_path__ + "static/media/mark_as_paid.eb3eed8c.svg";